import React, { useState } from 'react';
import './VideoSection.css';

const VideoSection = () => {
const [activeVideo, setActiveVideo] = useState(null);

const videos = [
{
    id: 'kBc7RK747Vg',
    title: 'THERMALS GREATEST WEAKNESS',
    description: 'A video of Joe going crazy style'
},
{
    id: 'i0q78XaGmYU',
    title: 'OPFOR SPOTTED',
    description: 'spying on a raccoon in the woods'
}
];

const openVideoModal = (videoId) => {
setActiveVideo(videoId);
document.body.style.overflow = 'hidden'; // Prevent scrolling when modal is open
};

const closeVideoModal = () => {
setActiveVideo(null);
document.body.style.overflow = 'auto'; // Allow scrolling again
};

return (
<div className="video-section">
    <div className="video-container">
    {videos.map((video) => (
        <div 
        key={video.id} 
        className="video-card"
        onClick={() => openVideoModal(video.id)}
        >
        <div className="video-thumbnail">
            <img 
            src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`} 
            alt={video.title}
            className="thumbnail-img"
            />
            <div className="play-button">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="40" cy="40" r="39" stroke="white" strokeWidth="2" fillOpacity="0.5" fill="black"/>
                <path d="M55 40L32.5 52.9904L32.5 27.0096L55 40Z" fill="white"/>
            </svg>
            </div>
        </div>
        <div className="video-overlay">
            <h3 className="video-title">{video.title}</h3>
            {video.description && <p className="video-description">{video.description}</p>}
        </div>
        </div>
    ))}
    </div>

    {/* Video Modal */}
    {activeVideo && (
    <div className="video-modal" onClick={closeVideoModal}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={closeVideoModal}>×</button>
        <div className="video-iframe-container">
            <iframe
            src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            ></iframe>
        </div>
        </div>
    </div>
    )}
</div>
// TODO: implement a way to add custom thumbnails (unlisted YT videos don't have thumbnails)
);
};

export default VideoSection;